import Section from './ColorSamplesSection'
import isEmpty from './ColorSamplesIsEmpty'

export default { Section, isEmpty }
